module.exports = __webpack_public_path__ + "static/media/noun-pool-2548920-808080.e3efffde.svg";